import imgOne from '../../assets/blogs/1.png';
import imgTwo from '../../assets/blogs/2.png';
import imgThree from '../../assets/blogs/3.png';

const BlogData = [
    {
        'img': imgOne,
        'url': 'new-technology-make-for-dental-operation',
        'title':'Nova Tecnologia para Operações Dentárias',
        'description':'Descubra como as mais recentes tecnologias estão transformando as operações dentárias, tornando os tratamentos mais precisos, rápidos e confortáveis para os pacientes. ',
        'category': 'TECNOLOGIA'
    },
     {
        'img': imgTwo,
        'url':'regular-dental-care-make-your-smile-brighter',
        'title':'Cuidados Dentários Regulares Deixam Seu Sorriso Mais Brilhante',
        'description':'Manter consultas regulares e uma boa rotina de cuidados dentários ajuda a prevenir problemas, fortalecer os dentes e garantir um sorriso sempre saudável e radiante. ',
        'category': 'DENTÁRIO'
    },
    {
        'img': imgThree,
        'url':'dental-hygiene-for-all-age-to-make-smile',
        'title':'Higiene Dentária para Todas as Idades para um Sorriso Saudável',
        'description':'A higiene dentária adequada é essencial em todas as idades. Aprenda técnicas eficazes para cuidar dos dentes e gengivas e manter um sorriso bonito e saudável por toda a vida. ',
        'category': 'HIGIENE'
    }
];

export default BlogData;